import { DropdownOption } from '@urbanx/agx.ui-components2';
import { LicenceDetailsState } from '@urbanx/agx.agencies.client';

export const agencyStateOptions: DropdownOption[] = [
  { value: LicenceDetailsState.ACT, label: 'ACT' },
  { value: LicenceDetailsState.NSW, label: 'NSW' },
  { value: LicenceDetailsState.QLD, label: 'QLD' },
  { value: LicenceDetailsState.NT, label: 'NT' },
  { value: LicenceDetailsState.SA, label: 'SA' },
  { value: LicenceDetailsState.TAS, label: 'TAS' },
  { value: LicenceDetailsState.VIC, label: 'VIC' },
  { value: LicenceDetailsState.WA, label: 'WA' },
];
